module.exports = __webpack_public_path__ + "img/pssicon.2f56ed99.svg";